import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { TOKEN_LIST_COLUMN_LABEL_I18N_KEY } from '../token-list/token-list.config';
import { useTokenListContext } from '../token.context';

export const TokenListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useTokenListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={TOKEN_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
